import { computed, ref } from "@vue/composition-api";
import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

const device = new useItem(gqlItem);
const devices = new useList(gqlList);

export default function(filters) {
  const showFields = ref([
    'name',
    'favourite',
    'muted',
    'enabled',
    'deviceBatteryLevel',
    'deviceBatteryType',
    'deviceResponseStatus',
    'deviceEmulation',
    'drivername',
    'editorgroup',
    'usergroup',
    'readergroup'
  ]);
  return {
    device,
    devices: {
      ...devices,
      visibleFields: computed({
        get: () => {
          let withAdditional = [...devices.visibleFields.value];
          const sorted = showFields.value.map(i => {
            return withAdditional.find(e => e === i);
          });
          if (withAdditional.length) {
            return sorted;
          }
          return [];
        },
        set: arr => {
          showFields.value = arr;
          devices.visibleFields.value = arr;
        }
      }),
      fields: computed(() => {
        let withAdditional = [...devices.fields.value];
        const sorted = showFields.value.map(i => {
          return withAdditional.find(e => e.field === i);
        });
        if (withAdditional.length) {
          return sorted;
        }
        return [];
      })
    }
  };
}
